import { cn } from '@/lib/utils'

type LogoVariant = 'light' | 'dark'

type LogoProps = {
  variant?: LogoVariant
  width?: number
  height?: number
  hoverable?: boolean
  useCurrentColor?: boolean
  className?: string
}

export function DossLogo({
  variant = 'light',
  width = 32,
  height = 32,
  hoverable = true,
  useCurrentColor = false,
  className,
}: LogoProps) {
  const fillClass = useCurrentColor
    ? 'fill-current'
    : {
        dark: 'fill-[#171F27]',
        light: 'fill-[#B8C3CC]',
      }[variant]

  const hoverClass = useCurrentColor
    ? ''
    : {
        dark: 'group-hover:fill-[#11181E]',
        light: 'group-hover:fill-[#FFFFFF]',
      }[variant]

  return (
    <div
      className={cn(
        'border-radius-2',
        'group',
        'inline-flex',
        hoverable && 'cursor-pointer hover:bg-gray-12',
        className,
      )}
    >
      <svg
        fill="none"
        height={height}
        viewBox="8 8 16 16"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={cn(fillClass, hoverable && hoverClass)}
          clipRule="evenodd"
          d="M8 8.12669C8 8.05672 8.05673 8 8.1267 8H19.3028C19.3728 8 19.4295 8.05672 19.4295 8.12669V12.5714H12.5718V19.4286H8.1267C8.05673 19.4286 8 19.3718 8 19.3019V8.12669Z"
          fillRule="evenodd"
        />
        <path
          className={cn(fillClass, hoverable && hoverClass)}
          clipRule="evenodd"
          d="M24 23.8733C24 23.9433 23.9433 24 23.8733 24H12.6972C12.6272 24 12.5705 23.9433 12.5705 23.8733V19.4286H19.4282V12.5714H23.8733C23.9433 12.5714 24 12.6282 24 12.6981V23.8733Z"
          fillRule="evenodd"
        />
      </svg>
    </div>
  )
}
